import { autoinject, LogManager } from 'aurelia-framework';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { AppEvents } from "core/app-events";
import { Item, ItemType, GanttInfo } from "data/entities/entities";
import { GanttInfoService } from 'data/service/gantt-info-service';

@autoinject()
export class Gantt {

	edit = { allowEditing: true, allowAdding: true, allowDeleting: true };
	toolbar = { showToolbar: true, toolbarItems: [ej.Grid.ToolBarItems.Add, ej.Grid.ToolBarItems.Edit, ej.Grid.ToolBarItems.Delete, ej.Grid.ToolBarItems.Update, ej.Grid.ToolBarItems.Cancel] };
	validorder = { required: true, number: true };
	validationcustomer = { required: true, minlength: 3 };
	validationdate = { date: true };
	valid = { number: true };
	validationfreight = { range: [0, 1000] };
	editparams = { decimalPlaces: 2 };
	formatfreight = '{0:c2}';
	formatdate = '{0:MM/dd/yyyy hh:mm:ss}';
	dropdown = 'dropdown';
	datetimepicker = ej.Grid.EditingType.DateTimePicker;
	numeric = ej.Grid.EditingType.Numeric;
	editboolean = ej.Grid.EditingType.Boolean;

	gridData = [
		{
			OrderID: 10248, CustomerID: "VINET", EmployeeID: 5, OrderDate: new Date(8364186e5), ShipName: "Vins et alcools Chevalier", ShipCity: "Reims", ShipAddress: "59 rue de Abbaye", ShipRegion: null, ShipPostalCode: "51100", ShipCountry: "France", Freight: 32.38, Verified: !0, Tags:['A','B']
		},
		{
			OrderID: 10249, CustomerID: "TOMSP", EmployeeID: 6, OrderDate: new Date(836505e6), ShipName: "Chop suey Chinese", ShipCity: "Monster", ShipAddress: "Luisenstr. 48", ShipRegion: null, ShipPostalCode: "44087", ShipCountry: "Germany", Freight: 11.61, Verified: !1, Tags: ['A', 'B']
		},
		{
			OrderID: 10250, CustomerID: "HANAR", EmployeeID: 4, OrderDate: new Date(8367642e5), ShipName: "Hanari Carnes", ShipCity: "Rio de Janeiro", ShipAddress: "Kirchgasse 6", ShipRegion: "RJ", ShipPostalCode: "05454-876", ShipCountry: "Brazil", Freight: 65.83, Verified: !0
		},
		{
			OrderID: 10251, CustomerID: "VICTE", EmployeeID: 3, OrderDate: new Date(8367642e5), ShipName: "Victuailles en stock", ShipCity: "Lyon", ShipAddress: "2, rue du Commerce", ShipRegion: null, ShipPostalCode: "69004", ShipCountry: "France", Freight: 41.34, Verified: !0
		},
		{
			OrderID: 10252, CustomerID: "SUPRD", EmployeeID: 4, OrderDate: new Date(8368506e5), ShipName: "Ernst Handel", ShipCity: "Charleroi", ShipAddress: "Boulevard Tirou, 255", ShipRegion: null, ShipPostalCode: "B-6000", ShipCountry: "Belgium", Freight: 51.3, Verified: !0
		},
		{
			OrderID: 10253, CustomerID: "HANAR", EmployeeID: 3, OrderDate: new Date(836937e6), ShipName: "Hanari Carnes", ShipCity: "Rio de Janeiro", ShipAddress: "Rua do Paco, 67", ShipRegion: "RJ", ShipPostalCode: "05454-876", ShipCountry: "Brazil", Freight: 58.17, Verified: !0
		},
		{
			OrderID: 10254, CustomerID: "CHOPS", EmployeeID: 5, OrderDate: new Date(8370234e5), ShipName: "Chop suey Chinese", ShipCity: "Bern", ShipAddress: "Hauptstr. 31", ShipRegion: null, ShipPostalCode: "3012", ShipCountry: "Switzerland", Freight: 22.98, Verified: !1
		},
		{
			OrderID: 10255, CustomerID: "RICSU", EmployeeID: 9, OrderDate: new Date(8371098e5), ShipName: "Richter Supermarkt", ShipCity: "Albuquerque", ShipAddress: "Starenweg 5", ShipRegion: null, ShipPostalCode: "1204", ShipCountry: "Switzerland", Freight: 148.33, Verified: !0
		},
		{
			OrderID: 10256, CustomerID: "WELLI", EmployeeID: 3, OrderDate: new Date(837369e6), ShipName: "Wellington Importadora", ShipCity: "Resende", ShipAddress: "Rua do Mercado, 12", ShipRegion: "SP", ShipPostalCode: "08737-363", ShipCountry: "Brazil", Freight: 13.97, Verified: !1
		},
		{
			OrderID: 10257, CustomerID: "HILAA", EmployeeID: 4, OrderDate: new Date(8374554e5), ShipName: "HILARION-Abastos", ShipCity: "Strasbourg", ShipAddress: "Carrera 22 con Ave. Carlos Soublette #8-35", ShipRegion: "NM", ShipPostalCode: "5022", ShipCountry: "Venezuela", Freight: 81.91, Verified: !0
		},
		{
			OrderID: 10258, CustomerID: "ERNSH", EmployeeID: 1, OrderDate: new Date(8375418e5), ShipName: "Ernst Handel", ShipCity: "Graz", ShipAddress: "Kirchgasse 6", ShipRegion: null, ShipPostalCode: "8010", ShipCountry: "Austria", Freight: 140.51, Verified: !0
		},
		{
			OrderID: 10259, CustomerID: "WARTH", EmployeeID: 3, OrderDate: new Date(8383194e5), ShipName: "Wartian Herkku", ShipCity: "Oulu", ShipAddress: "Torikatu 38", ShipRegion: null, ShipPostalCode: "90110", ShipCountry: "Finland", Freight: 25.73, Verified: !1
		},
		{
			OrderID: 10260, CustomerID: "ROMEY", EmployeeID: 4, OrderDate: new Date(839961e6), ShipName: "Romero y tomillo", ShipCity: "Madrid", ShipAddress: "Magazinweg 7", ShipRegion: null, ShipPostalCode: "28001", ShipCountry: "Spain", Freight: 2.94, Verified: !1
		},
		{
			OrderID: 10261, CustomerID: "QUEDE", EmployeeID: 4, OrderDate: new Date(8377146e5), ShipName: "Vins et alcools Chevalier", ShipCity: "Rio de Janeiro", ShipAddress: "Rua da Panificadora, 12", ShipRegion: "RJ", ShipPostalCode: "02389-673", ShipCountry: "Brazil", Freight: 3.05, Verified: !1
		},
		{
			OrderID: 10262, CustomerID: "RATTC", EmployeeID: 8, OrderDate: new Date(8379738e5), ShipName: "Rattlesnake Canyon Grocery", ShipCity: "Albuquerque", ShipAddress: "2817 Milton Dr.", ShipRegion: "NM", ShipPostalCode: "87110", ShipCountry: "USA", Freight: 48.29, Verified: !0
		},
		{
			OrderID: 10263, CustomerID: "ERNSH", EmployeeID: 9, OrderDate: new Date(8380602e5), ShipName: "Ernst Handel", ShipCity: "Graz", ShipAddress: "Kirchgasse 6", ShipRegion: null, ShipPostalCode: "8010", ShipCountry: "Austria", Freight: 146.06, Verified: !0
		},
		{
			OrderID: 10264, CustomerID: "FOLKO", EmployeeID: 6, OrderDate: new Date(8381466e5), ShipName: "LILA-Supermercado", ShipCity: "Tsawassen", ShipAddress: "23 Tsawassen Blvd.", ShipRegion: null, ShipPostalCode: "S-844 67", ShipCountry: "Sweden", Freight: 3.67, Verified: !1
		},
		{
			OrderID: 10265, CustomerID: "BLONP", EmployeeID: 2, OrderDate: new Date(838233e6), ShipName: "Magazzini Alimentari Riuniti", ShipCity: "Strasbourg", ShipAddress: "Avda. Azteca 123", ShipRegion: null, ShipPostalCode: "67000", ShipCountry: "France", Freight: 55.28, Verified: !0
		},
		{
			OrderID: 10267, CustomerID: "FRANK", EmployeeID: 4, OrderDate: new Date(8385786e5), ShipName: "Frankenversand", ShipCity: "Leipzig", ShipAddress: "Berliner Platz 43", ShipRegion: null, ShipPostalCode: "80805", ShipCountry: "Germany", Freight: 208.58, Verified: !0
		},
		{
			OrderID: 10268, CustomerID: "GROSR", EmployeeID: 8, OrderDate: new Date(838665e6), ShipName: "GROSELLA-Restaurante", ShipCity: "Caracas", ShipAddress: "Avda. Azteca 123", ShipRegion: "DF", ShipPostalCode: "1081", ShipCountry: "Venezuela", Freight: 66.29, Verified: !0
		},
		{
			OrderID: 10269, CustomerID: "WHITC", EmployeeID: 5, OrderDate: new Date(8387514e5), ShipName: "White Clover Markets", ShipCity: "Seattle", ShipAddress: "1029 - 12th Ave. S.", ShipRegion: "WA", ShipPostalCode: "98124", ShipCountry: "USA", Freight: 4.56, Verified: !1
		},
		{
			OrderID: 10270, CustomerID: "WARTH", EmployeeID: 1, OrderDate: new Date(8388378e5), ShipName: "Wartian Herkku", ShipCity: "Oulu", ShipAddress: "Torikatu 38", ShipRegion: null, ShipPostalCode: "90110", ShipCountry: "Finland", Freight: 136.54, Verified: !0
		},
		{
			OrderID: 10271, CustomerID: "SPLIR", EmployeeID: 6, OrderDate: new Date(8388378e5), ShipName: "Split Rail Beer & Ale", ShipCity: "Lander", ShipAddress: "P.O. Box 555", ShipRegion: "WY", ShipPostalCode: "82520", ShipCountry: "USA", Freight: 4.54, Verified: !1
		},
		{
			OrderID: 10272, CustomerID: "RATTC", EmployeeID: 6, OrderDate: new Date(8389242e5), ShipName: "Rattlesnake Canyon Grocery", ShipCity: "Albuquerque", ShipAddress: "2817 Milton Dr.", ShipRegion: "NM", ShipPostalCode: "87110", ShipCountry: "USA", Freight: 98.03, Verified: !0
		},
		{
			OrderID: 10273, CustomerID: "QUICK", EmployeeID: 3, OrderDate: new Date(8391834e5), ShipName: "QUICK-Stop", ShipCity: "Cunewalde", ShipAddress: "Av. Copacabana, 267", ShipRegion: null, ShipPostalCode: "01307", ShipCountry: "Germany", Freight: 76.07, Verified: !0
		},
		{
			OrderID: 10274, CustomerID: "VINET", EmployeeID: 6, OrderDate: new Date(8392698e5), ShipName: "Vins et alcools Chevalier", ShipCity: "Reims", ShipAddress: "59 rue de Abbaye", ShipRegion: null, ShipPostalCode: "51100", ShipCountry: "France", Freight: 6.01, Verified: !1
		},
		{
			OrderID: 10275, CustomerID: "MAGAA", EmployeeID: 1, OrderDate: new Date(8393562e5), ShipName: "Magazzini Alimentari Riuniti", ShipCity: "Bergamo", ShipAddress: "Via Ludovico il Moro 22", ShipRegion: null, ShipPostalCode: "24100", ShipCountry: "Italy", Freight: 26.93, Verified: !1
		}
	]

}